module.exports = __webpack_public_path__ + "media/fonts/BasisGrotesquePro-Medium-1f7543d7a23ccc00f345849f479edb2b.woff";